import {
  FormInput,
  FormPhoneInput,
  FormSectionHeader,
  FormSelect,
  Heading,
  Loader,
} from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import {
  FIRST_NAME,
  EMAIL_ID,
  MOBILE_NO,
  EMP_ID,
  ADDRESS,
  STATE,
  CITY,
  ZIPCODE,
  LAST_NAME,
  TEMP_PASSWORD,
  FORCE_PASSWORD,
} from "./consts";
import { Button } from "@/components/ui";

const AddEdit = () => {
  const {
    title,
    onBackClick,
    breadcrumbData,
    isView,
    form,
    requiredFields,
    onSubmit,
    keys,
    onPhoneCountryChange,
    countryCode,
    onCancel,
    isAddEmployeePending,
    isLoadingEmployeeDetails,
    isLoadingStates,
    stateList,
    isLoadingCity,
    cityList,
    isPassword,
    onEyeIconClick,
    Icon,
    isEdit,
    id,
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={title}
            showBack
            onBackClick={onBackClick}
            breadcrumbData={breadcrumbData}
          />
        </div>
      </div>

      {isLoadingEmployeeDetails || isLoadingStates ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
              <div>
                <FormSectionHeader>Basic Information</FormSectionHeader>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[30px]">
                  <FormInput
                    name={FIRST_NAME}
                    control={form.control}
                    label="First Name"
                    placeholder="Please enter"
                    error={errors[FIRST_NAME]?.message}
                    isRequired={requiredFields.includes(FIRST_NAME)}
                    disabled={isView}
                    maxLength={50}
                  />
                  <FormInput
                    name={LAST_NAME}
                    control={form.control}
                    label="Last Name"
                    placeholder="Please enter"
                    error={errors[LAST_NAME]?.message}
                    isRequired={requiredFields.includes(LAST_NAME)}
                    disabled={isView}
                    maxLength={50}
                  />
                  <FormInput
                    name={EMAIL_ID}
                    control={form.control}
                    label="Email ID"
                    placeholder="Please enter"
                    error={errors[EMAIL_ID]?.message}
                    isRequired={requiredFields.includes(EMAIL_ID)}
                    disabled={isView}
                    autoComplete="new-email"
                  />
                  <FormPhoneInput
                    name={MOBILE_NO}
                    control={form.control}
                    label="Phone No"
                    placeholder="Please enter"
                    error={errors[MOBILE_NO]?.message}
                    isRequired={requiredFields.includes(MOBILE_NO)}
                    disabled={isView}
                    onlyCountries={["in"]}
                    disableDropdown={isView}
                    disableCountryCode={isView}
                    disableCountryGuess={isView}
                    onChange={onPhoneCountryChange}
                    country={"in"}
                  />
                  <FormInput
                    name={EMP_ID}
                    control={form.control}
                    label="Employment ID"
                    placeholder="Please enter"
                    error={errors[EMP_ID]?.message}
                    isRequired={requiredFields.includes(EMP_ID)}
                    disabled={isView}
                  />
                  {!id || (isEdit && form.watch(FORCE_PASSWORD)) ? (
                    <FormInput
                      name={TEMP_PASSWORD}
                      control={form.control}
                      label="Temporary Password"
                      placeholder="Please enter"
                      error={errors[TEMP_PASSWORD]?.message}
                      isRequired={requiredFields.includes(TEMP_PASSWORD)}
                      disabled={isView}
                      type={isPassword ? "password" : "text"}
                      endIcon={
                        <Icon className="h-4 w-4" onClick={onEyeIconClick} />
                      }
                      autoComplete="new-password"
                    />
                  ) : (
                    <></>
                  )}
                  <div className="md:col-span-2">
                    <FormInput
                      name={`${ADDRESS}`}
                      control={form.control}
                      label="Address"
                      placeholder="Please enter"
                      error={errors[`${ADDRESS}`]?.message}
                      isRequired={requiredFields.includes(`${ADDRESS}`)}
                      disabled={isView}
                    />
                  </div>
                  <FormSelect
                    key={keys.state}
                    name={`${STATE}`}
                    control={form.control}
                    label="State"
                    placeholder="Please select"
                    error={errors[`${STATE}`]?.message}
                    isRequired={requiredFields.includes(`${STATE}`)}
                    options={
                      stateList?.data?.map((data: any) => ({
                        label: data?.name,
                        value: data?.stateId?.toString(),
                      })) || []
                    }
                    disabled={isView}
                  />
                  <FormSelect
                    key={keys.city}
                    name={`${CITY}`}
                    control={form.control}
                    label="City"
                    placeholder="Please select"
                    error={errors[`${CITY}`]?.message}
                    isRequired={requiredFields.includes(`${CITY}`)}
                    options={
                      cityList?.data?.map((data: any) => ({
                        label: data?.name,
                        value: data?.cityId?.toString(),
                      })) || []
                    }
                    disabled={
                      isView || !form.watch(`${STATE}`) || isLoadingCity
                    }
                  />
                  <FormInput
                    name={`${ZIPCODE}`}
                    control={form.control}
                    label="PIN"
                    placeholder="Please enter"
                    error={errors[`${ZIPCODE}`]?.message}
                    isRequired={requiredFields.includes(`${ZIPCODE}`)}
                    maxLength={countryCode == "USA" ? 5 : 6}
                    disabled={isView}
                    variant="integer"
                  />
                </div>
              </div>
              <div className="flex flex-row justify-end gap-3  py-3">
                <Button variant="outline" type="button" onClick={onCancel}>
                  Cancel
                </Button>

                <Button type="submit" disabled={isAddEmployeePending}>
                  {" "}
                  {isAddEmployeePending ? (
                    <Loader variant="secondary" />
                  ) : (
                    <></>
                  )}{" "}
                  Save
                </Button>
              </div>
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default AddEdit;
